(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.nsReady === 'true') return;
    root.dataset.nsReady = 'true';

    var faqItems = Array.prototype.slice.call(root.querySelectorAll('[data-ns-faq-item]'));
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function closeItem(item) {
      var btn = item.querySelector('[data-ns-faq-btn]');
      var panel = item.querySelector('[data-ns-faq-panel]');
      item.classList.remove('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (panel) {
        panel.hidden = true;
        panel.setAttribute('hidden', '');
      }
    }

    function openItem(item) {
      var btn = item.querySelector('[data-ns-faq-btn]');
      var panel = item.querySelector('[data-ns-faq-panel]');
      item.classList.add('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.hidden = false;
        panel.removeAttribute('hidden');
      }
    }

    faqItems.forEach(function (item) {
      var btn = item.querySelector('[data-ns-faq-btn]');
      if (!btn) return;
      closeItem(item);
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var isOpen = item.classList.contains('is-open');
        faqItems.forEach(function (other) {
          if (other !== item) closeItem(other);
        });
        if (isOpen) closeItem(item);
        else openItem(item);
      });
    });

    document.addEventListener('shopify:block:select', function (event) {
      if (!root.contains(event.target)) return;
      faqItems.forEach(function (item) {
        item.classList.remove('is-selected');
      });
      var faq = event.target.closest('[data-ns-faq-item]');
      if (faq) {
        faq.classList.add('is-selected');
        openItem(faq);
        faq.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest' });
      }
    });

    document.addEventListener('shopify:block:deselect', function () {
      faqItems.forEach(function (item) {
        item.classList.remove('is-selected');
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-nogag-shipping]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target && event.target.querySelector
        ? event.target.querySelector('[data-nogag-shipping]') ||
          (event.target.matches && event.target.matches('[data-nogag-shipping]') ? event.target : null)
        : null;
    if (section) {
      section.dataset.nsReady = 'false';
      initSection(section);
    }
  });
})();
